export const common = {
  processing: 'Estamos procesando tu solicitud...',
  defaultErrorTitle: 'Algo salió mal',
  defaultRetryButton: 'Intentar de nuevo',
  weightInputAriaLabel: 'Peso en libras',
  heightFeetAriaLabel: 'Altura en pies',
  heightInchesAriaLabel: 'Altura en pulgadas',
  goToHome: 'Ir al inicio',
};

export const iframe = {
  updatePaymentMethod: 'Actualizar Método de Pago',
  payment: 'Pago',
};

export const wallet = {
  errors: {
    notSupported: 'Wallet no es compatible con esta plataforma',
    downloadFailed: 'Error al descargar el pase de wallet',
    appleWalletFailed: 'Error al añadir a Apple Wallet',
    googleWalletFailed: 'Error al añadir a Google Wallet',
  },
};
